import { types } from 'mobx-state-tree'
import { isAfter, differenceInSeconds } from 'date-fns'
import { ConvertableDate } from 'store/types/date'
import { extractJWTPayload } from 'utils/standard/jwt'

export const Token = types
  .model('Token', {
    raw: types.string,
    relatedEntityId: types.number,
    expirationDate: ConvertableDate,
  })
  .preProcessSnapshot((token) => {
    if (!token) {
      return token
    }

    const { sub, exp } = extractJWTPayload(token)

    return {
      raw: token,
      relatedEntityId: Number(sub),
      expirationDate: new Date(exp * 1000),
    }
  })
  .views((self) => ({
    get isExpired() {
      return isAfter(new Date(), self.expirationDate)
    },

    get isAboutToExpire() {
      // ten seconds means is about to expire
      return differenceInSeconds(self.expirationDate, new Date()) < 10
    },

    toString() {
      return self.raw
    },
  }))
